import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import {
  Container,
  Tabs,
  Tab,
  Box,
  Typography,
} from '@mui/material';
import ProjectsManagement from '../components/admin/ProjectsManagement';
import DepartmentsManagement from '../components/admin/DepartmentsManagement';
import WorkTypesManagement from '../components/admin/WorkTypesManagement';
import MaterialsManagement from '../components/admin/MaterialsManagement';
import { useTranslation } from 'react-i18next';

const ReferencePage: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [value, setValue] = useState(() => {
    const path = location.pathname;
    if (path.includes('/projects')) return 0;
    if (path.includes('/departments')) return 1;
    if (path.includes('/work-types')) return 2;
    if (path.includes('/materials')) return 3;
    return 0;
  });

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        {t('admin.referenceData')}
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        {t('admin.referenceDataDescription')}
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={value} onChange={(e, newValue) => setValue(newValue)}>
          <Tab label={t('admin.projects')} component={Link} to="/reference/projects" />
          <Tab label={t('admin.departments')} component={Link} to="/reference/departments" />
          <Tab label={t('admin.workTypes')} component={Link} to="/reference/work-types" />
          <Tab label={t('admin.materials')} component={Link} to="/reference/materials" />
        </Tabs>
      </Box>
      <Routes>
        <Route path="projects" element={<ProjectsManagement />} />
        <Route path="departments" element={<DepartmentsManagement />} />
        <Route path="work-types" element={<WorkTypesManagement />} />
        <Route path="materials" element={<MaterialsManagement />} />
        <Route index element={<ProjectsManagement />} />
      </Routes>
    </Container>
  );
};

export default ReferencePage;



